import axios from "axios";
// const url = process.env.REACT_APP_API_URI;

export const fetchIpdRelease = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/IPD/admitted`);
};

export const fetchIpdVoucher = (ipdId) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/IPD/${ipdId}/Vouchers`);
};

export const podtApproval = (ipdId, data) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/IPD/${ipdId}/approval`, data);
};


